export interface StatusReason {
  title: string;
  statusCode: string;
  statusDescriptionFDA: string;
  statusDescriptionDotcomUI: string;
  priority: string;
  color: string;
  errorType: string;
}

export interface TravelDocsErrors {
  [key: string]: StatusReason;
}
